export default "__VITE_ASSET__QRhJ4HfY__"